module.exports = ally;


//////////////////
// WEBPACK FOOTER
// external "ally"
// module id = external "ally"
// module chunks = core